// let showToast: (msg: string) => void;

// export const setToastFunction = (fn: (msg: string) => void) => {
//   showToast = fn;
// };

// export const triggerToast = (msg: string, type?: "success" | "error") => {
//   if (showToast) showToast(msg);
// };

let showToast: (msg: string, type?: "success" | "error") => void;

export const setToastFunction = (fn: (msg: string, type?: "success" | "error") => void) => {
  showToast = fn;
};

export const triggerToast = (msg: string, type?: "success" | "error") => {
  if (showToast) showToast(msg, type);
};
